import { useCallback, useEffect, useRef, useState } from "react";

import { get } from "utils/DeV2Api";

const useFetchScopeNMetadata = ({
  page = 1,
  perPage = 10,
  onSuccess,
  onError,
  protocolId,
  fetchByDefault = true,
}) => {
  const subscribedPromises = useRef([]);
  const [meta, setMeta] = useState();
  const [error, setError] = useState("");

  const [scopeNMetadata, setScopeNMetadata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onErrorRef = useRef(onError);
  const onSuccessRef = useRef(onSuccess);

  const fetchScopeNMetadata = useCallback(
    ({ silent = false }) => {
      if (!silent) setIsLoading(true);
      const scopeNMetadataPromise = get(
        `protocols/${protocolId}/audit-metadata`,
        {
          params: { page, perPage },
        },
      );
      scopeNMetadataPromise.promise
        .then((response) => {
          setMeta(response?.meta);
          setScopeNMetadata(response?.data);
          if (typeof onSuccessRef.current === "function")
            onSuccessRef.current(response?.data);
        })
        .catch((error) => {
          if (!error.isCanceled) {
            setError(error);
            if (typeof onErrorRef.current === "function")
              onErrorRef.current(error);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
      subscribedPromises.current.push(scopeNMetadataPromise);
    },
    [page, perPage, protocolId],
  );

  useEffect(() => {
    if (protocolId && fetchByDefault) fetchScopeNMetadata({ silent: false });

    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((promise) => {
        promise.cancel();
      });
    };
  }, [fetchByDefault, protocolId, fetchScopeNMetadata]);

  return {
    meta,
    error,
    isLoading,
    scopeNMetadata,
    setScopeNMetadata,
    fetchScopeNMetadata,
  };
};

export default useFetchScopeNMetadata;
